import { normalizeLocale as e } from "../config.mjs";
//#region src/adapter/webLocaleAdapter.ts
var t = "locale", n = 3600 * 24 * 365, r = {
	getInitialLocale() {
		if (typeof document > "u") return "en";
		let n = document.cookie.split("; ").find((e) => e.startsWith(`${t}=`))?.split("=")[1];
		return e(n && decodeURIComponent(n)) ?? "en";
	},
	persistLocale(e) {
		typeof document > "u" || (document.cookie = `${t}=${encodeURIComponent(e)};path=/;max-age=${n};SameSite=Lax`);
	},
	setDocumentDir(e, t) {
		typeof document > "u" || (document.documentElement.dir = e, document.documentElement.lang = t);
	}
};
//#endregion
export { r as webLocaleAdapter };
